import QlikFilter from "./QlikFilter";
import React from 'react';
import ReactDOM from 'react-dom';
import getApp from './qapp';
import getLocation from './locate';
import 'tether';
import 'bootstrap';
import moment from 'moment-timezone';
var Promise = require("bluebird");

ReactDOM.render(
  <QlikFilter name="Select your location" field="City_St" rowHeight="40px"></QlikFilter>,
  document.getElementById('location-filter')
);


getLocation.then(() => {
  $("#loader").hide();
  $("#main-content").show();
  getApp.then(app => {
    // app.visualization.get('ZGmUmB').then(vis => {
    //   vis.show('qmap');
    // });
    // app.visualization.get('Jyxwp').then(vis => {
    //   vis.show('qmap-route');
    // });
    // app.visualization.get('hStmj').then(vis => {
    //   vis.show('qmap-origin');
    // });
    // app.visualization.get('eZDuxby').then(vis => {
    //   vis.show('qmap-destination');
    // });
    // app.visualization.get('ymKptJ').then(vis => {
    //   vis.show('qmap-path');
    // });
    app.visualization.get('NBBbzJJ').then(vis => {
      vis.show('qmap');
    });

    //stuff for clock and eclipse viz
    app.createGenericObject({
      obscurationString: {
        qStringExpression: "num(Only(Obscuration), '#.#%')"
      },
      obscurationValue: {
        qValueExpression: "Only(Obscuration)"
      },
      magnitudeValue: {
        qValueExpression: "Only(Magnitude)"
      },
      totalityDuration: {
        qStringExpression: `time(Only({<Phenomenon={'Totality Ends'}>} Time)-Only({<Phenomenon={'Totality Begins'}>} Time), 'mm:ss')`
      },
      possibleCities: {
        qValueExpression: 'count({<City_St=P()>} DISTINCT City_St)'
      },
      timeForTotal: {
        qStringExpression: 'Only({<Phenomenon={"Eclipse Begins"}>} [Time])'
      },
      timezone: {
        qStringExpression: `only([time_zone])`
      }
    }, reply => {
      let timeForTotal = reply.timeForTotal;
      let timezone = reply.timezone;

      var eBegin = "2024-04-08 " + timeForTotal;
      var utc = moment.utc(eBegin);
      var converted = utc.tz(timezone).format();
      setCountdown(converted);

      let red = Math.round(135 - Math.pow(1+reply.obscurationValue, 10)*(135/Math.pow(2, 10)) );
      let green = Math.round(206 - Math.pow(1+reply.obscurationValue, 10)*(206/Math.pow(2, 10)));
      let blue = Math.round(235 - Math.pow(1+reply.obscurationValue, 10)*(235/Math.pow(2, 10)));
    
      $("#eclipse-viz").off();
      $("#eclipse-viz").click(() => {
        $("#eclipse-viz").css("transition", "none").css("background-color","rgb(135,206,235)")
        $("#obscuration-circle").css("transition", "none").css("left", "100%")
        setTimeout(() => {
          $("#eclipse-viz").css("transition", "background-color 3s ease").css("background-color", `rgb(${red},${green},${blue})`);
          $("#obscuration-circle").css("transition", "left 3s ease").css("left", `calc(50% - 75px + 150px - ${Math.min(reply.magnitudeValue,1)*150}px`);
        }, 100);
      });
      $("#eclipse-viz").trigger("click");

      // $("#obscuration-display").html(reply.obscurationString);
      // $("#eclipse-duration-display").html(reply.totalityDuration);
      // if (reply.totalityDuration != "-") {
      //   $("#obscuration-display").parent().hide();
      //   $("#eclipse-duration-display").parent().show();
      // } else {
      //   $("#obscuration-display").parent().show();
      //   $("#eclipse-duration-display").parent().hide();
      // }
    });

    //origin/destination
    app.createGenericObject({
      origin: {
        qStringExpression: `only([City_St])`
      },
      originLat: {
        qValueExpression: `only([latitude])`
      },
      originLng: {
        qValueExpression: `only([longitude])`
      },
      destination: {
        qStringExpression: `only([Destination.City_St])`
      },
      destinationLat: {
        qValueExpression: `only([Destination.latitude])`
      },
      destinationLng: {
        qValueExpression: `only([Destination.longitude])`
      }
    }, reply => {
      if (reply.origin != "-" && reply.destination != "-") {
        let origin = {lat: reply.originLat, lng: reply.originLng};
        let destination = {lat: reply.destinationLat, lng: reply.destinationLng};
        //findNearestTotalEclipse(origin, destination);
      }
    });

    //location table
    app.createCube({
      qDimensions: [{
        qDef: {
          qFieldDefs: [`City_St`]
        }
      }],
      qMeasures: [{
        qDef: {
          qDef: `only({<[Phenomenon]={'Eclipse Begins'}>} Time)`
        }
      },{
        qDef: {
          qDef: `only({<[Phenomenon]={'Totality Begins'}>} Time)`
        }
      },{
        qDef: {
          qDef: `only({<[Phenomenon]={'Maximum Eclipse'}>} Time)`
        }
      },{
        qDef: {
          qDef: `only({<[Phenomenon]={'Totality Ends'}>} Time)`
        }
      },{
        qDef: {
          qDef: `only({<[Phenomenon]={'Eclipse Ends'}>} Time)`
        }
      },{
        qDef: {
          qDef: `num(only(Obscuration),'#.#%')`
        }
      },{
        qDef: {
          qDef: `time(Only({<Phenomenon={'Totality Ends'}>} Time)-Only({<Phenomenon={'Totality Begins'}>} Time), 'mm:ss')`
        }
      },{
        qDef: {
          qDef: `only(time_zone)`
        }
      }],
      qInitialDataFetch: [{
        qWidth: 10,
        qHeight: 1
      }]
    }, reply => {
      let matrix = reply.qHyperCube.qDataPages[0].qMatrix;
      $('.location-name').html(matrix[0][0].qText);
      $('.wyws-text').hide();
      if (matrix[0][6].qNum === 1) {
        $('#for-total-eclipse').show();
      } else {
        $('#for-partial-eclipse').show();
      }
      if (matrix[0][2].qText === '-') { $('#location-table tr:nth-child(2)').hide(); } else { $('#location-table tr:nth-child(2)').show(); }
      if (matrix[0][4].qText === '-') { $('#location-table tr:nth-child(4)').hide(); } else { $('#location-table tr:nth-child(4)').show(); }
      if (matrix[0][7].qText === '-') { $('#location-table tr:nth-child(7)').hide(); } else { $('#location-table tr:nth-child(7)').show(); }

      var begin = moment.utc("2024-04-08 " + matrix[0][1].qText).tz(matrix[0][8].qText).format("LTS z");
      $('#location-table tr:nth-child(1) td:last-child').html(begin);
      var tBegin = moment.utc("2024-04-08 " + matrix[0][2].qText).tz(matrix[0][8].qText).format("LTS z");
      $('#location-table tr:nth-child(2) td:last-child').html(tBegin);
      var max = moment.utc("2024-04-08 " + matrix[0][3].qText).tz(matrix[0][8].qText).format("LTS z");
      $('#location-table tr:nth-child(3) td:last-child').html(max);
      var tEnd = moment.utc("2024-04-08 " + matrix[0][4].qText).tz(matrix[0][8].qText).format("LTS z");
      $('#location-table tr:nth-child(4) td:last-child').html(tEnd);
      var end = moment.utc("2024-04-08 " + matrix[0][5].qText).tz(matrix[0][8].qText).format("LTS z");
      $('#location-table tr:nth-child(5) td:last-child').html(end);
      $('#location-table tr:nth-child(6) td:last-child').html(matrix[0][6].qText);
      $('#location-table tr:nth-child(7) td:last-child').html(matrix[0][7].qText);
      //setWeatherForecast(matrix[0][0].qText);
    });

    //destination table
    app.createCube({
      qDimensions: [{
        qDef: {
          qFieldDefs: [`Destination.City_St`]
        }
      }],
      qMeasures: [{
        qDef: {
          qDef: `only({<[Destination.Phenomenon]={'Totality Begins'}>} Destination.Time)`
        }
      },{
        qDef: {
          qDef: `only({<[Destination.Phenomenon]={'Maximum Eclipse'}>} Destination.Time)`
        }
      },{
        qDef: {
          qDef: `time(Only({<Destination.Phenomenon={'Totality Ends'}>} Destination.Time)-Only({<Destination.Phenomenon={'Totality Begins'}>} Destination.Time), 'm') & 'm ' & time(Only({<Destination.Phenomenon={'Totality Ends'}>} Destination.Time)-Only({<Destination.Phenomenon={'Totality Begins'}>} Destination.Time), 's') & 's'`
        }
      },{
        qDef: {
          qDef: `only([Destination.time_zone])`
        }
      },{
        qDef: {
          qDef: `time(Time#(Route_Duration, 's'), 'h') & 'h ' & time(Time#(Route_Duration, 's'), 'm') & 'm '`
        }
      }],
      qInitialDataFetch: [{
        qWidth: 10,
        qHeight: 1
      }]
    }, reply => {
      let matrix = reply.qHyperCube.qDataPages[0].qMatrix;
      $(".destination-name").html(matrix[0][0].qText);
      $("#distance-drive span").html(matrix[0][5].qText);
      var tStart = moment.utc("2024-04-08 " + matrix[0][1].qText).tz(matrix[0][4].qText).format('LTS z');
      $("#total-start").html(tStart);
      var tMax = moment.utc("2024-04-08 " + matrix[0][2].qText).tz(matrix[0][4].qText).format('LTS z');
      $("#max-eclipse").html(tMax);
      //format in m s
      $("#total-length").html(matrix[0][3].qText);
      $('[data-toggle="tooltip"]').tooltip(); 
    });

  });
});


//google tracking
$("#location-filter").click(() => {
  ga('send', 'event', 'filter', 'Location Filter', 'Location');
});
$("#qlik-logo").click(() => {
  ga('send', 'event', 'logo', 'Qlik', 'Go to qlik.com');
});


// WEBPACK FOOTER //
// ./main.js